export default __webpack_public_path__ + "static/media/aqua6.d51a3ed5.png";